import { render } from "./PageHeaderLayout.vue?vue&type=template&id=a95b2680&scoped=true"
import script from "./PageHeaderLayout.vue?vue&type=script&lang=js"
export * from "./PageHeaderLayout.vue?vue&type=script&lang=js"

import "./PageHeaderLayout.vue?vue&type=style&index=0&id=a95b2680&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a95b2680"

export default script